import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaPrint} from "react-icons/fa";
import {useEffect, useState} from "react";
import HeaderTemplateButton from "../../../../components/button/header-template-button.jsx";
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import janitorialService from "../../../../services/web/janitorial-service.js";
import {useParams} from "react-router";
import {useQuery} from "@tanstack/react-query";
import userService from "../../../../services/web/user-service.js";
import natureService from "../../../../services/web/nature-service.js";
import {format} from "date-fns";
import locationService from "../../../../services/web/location-service.js";
import placeService from "../../../../services/web/place-service.js";
import PrintHeader from "../../../../components/reports/print-reports/print-header.jsx";
import PrintFooter from "../../../../components/reports/print-reports/print-footer.jsx";
import {useJanitorialQueries} from "../../../web/janitorial/form/use-janitorial-queries.js";
import {buildJanitorialObj} from "../../../web/janitorial/janitorial-utils.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const JanitorialPrint = () => {
  const {id} = useParams();
  const [janitorial, setJanitorial] = useState({});
  const [headerSelected, setHeaderSelected] = useState(-1);
  const {agents,
    reasons,
    janitorialData,
    equipmentData,
    isGlobalLoading} = useJanitorialQueries(id);

  const { data: placeData = null, isLoading: isLoadingPlaceData} = useQuery({
    queryFn: () => locationService.getLocationById(janitorialData?.place),
    queryKey: ["place-data", janitorialData?.place],
    enabled: !!janitorialData?.place
  });
  const print = () => {
    window.print()
  }

  useEffect(() => {
    if(!janitorialData) return;

    setJanitorial({
      ...buildJanitorialObj(janitorialData),
      equipments: equipmentData || []
    });
  }, [janitorialData, equipmentData]);


  return(
    <>
      <Template isLoading={isGlobalLoading || isLoadingPlaceData} className="print:hidden ">
        <Template.Header>
          <Template.Title>Zeladoria</Template.Title>
          <div className="flex gap-2">
            <Button title="Imprimir" onClick={print}><FaPrint/></Button>
            <HeaderTemplateButton
              selected={headerSelected}
              setSelected={setHeaderSelected}
            />
          </div>
        </Template.Header>
        <Template.Body>
          <div className="bg-white px-5">
            <PrintHeader entity={headerSelected} title="ZELADORIA"/>
            <div className="w-full p-2">
              <table className="table-fixed border-collapse p-2">
                <thead>
                <tr>
                  <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Agente da abertura</th>
                  <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Data/hora de abertura</th>
                  <th colSpan={2} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Status</th>
                  <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Solicitante</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colSpan={3}  className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{agents.find(agent => agent.value === janitorial?.user_start)?.label}</td>
                  <td colSpan={4}  className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial.date_start ? format(janitorial.date_start, "dd/MM/yyyy HH:mm") : ""}</td>
                  <td colSpan={2}  className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.status === "OPEN" ? "Aberto" : "Encerrado"}</td>
                  <td colSpan={3}  className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.requester}</td>
                </tr>
                </tbody>
                <thead>
                <tr>
                  <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Natureza</th>
                  <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Agente de encerramento</th>
                  <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Data/hora encerramento</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colSpan={4} className="w-1/3 border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{reasons.find(reason => reason.value === janitorial?.reason)?.label}</td>
                  <td colSpan={4} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{agents.find(agent => agent.value === janitorial?.user_end)?.label}</td>
                  <td colSpan={4} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial.date_end ? format(janitorial.date_end, "dd/MM/yyyy HH:mm") : ""}</td>
                </tr>
                </tbody>
                <thead>
                <tr>
                  <th colSpan={12} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Descrição</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colSpan={12} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.description}</td>
                </tr>
                </tbody>
                <thead>
                <tr>
                  <th colSpan={12} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Anexo</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colSpan={12} className="border text-center p-2 border-[#d9dada] text-[#4f4f4f]">
                    <div className="w-full flex justify-center">
                      { janitorial.janitorial_file &&
                        <img className="h-auto w-auto" src={`${API_KEEPER}/ged/attach/${janitorial.janitorial_file}`}/>
                      }
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>

              <table className="w-full table-fixed border-collapse mt-4">
                <thead>
                <tr>
                  <th colSpan={12} className="border text-start p-2 bg-[#f4f4f5] border-[#d9dada] text-[#4f4f4f] font-bold">Endereço</th>
                </tr>
                </thead>
                <thead>
                <tr>
                  <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Local pré-cadastrado</th>
                  <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Tipo</th>
                  <th colSpan={5} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Logradouro</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colSpan={4} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{placeData?.name ?? ""}</td>
                  <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.type_place}</td>
                  <td colSpan={5} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.street}</td>
                </tr>
                </tbody>
                <thead>
                <tr>
                  <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Número</th>
                  <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Bairro</th>
                  <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Cruzamento</th>
                  <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Ponto de referência</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.number}</td>
                  <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.neighborhood}</td>
                  <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.crossroads}</td>
                  <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.reference_point}</td>
                </tr>
                </tbody>
                <thead>
                <tr>
                  <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Município</th>
                  <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Latitude</th>
                  <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Longitude</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colSpan={4} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.city}</td>
                  <td colSpan={4} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.latitude}</td>
                  <td colSpan={4} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.longitude}</td>
                </tr>
                </tbody>
              </table>


              <table className="w-full table-fixed border-collapse mt-4">
                <thead>
                <tr>
                  <th colSpan={12} className="border text-start p-2 bg-[#f4f4f5] border-[#d9dada] text-[#4f4f4f] font-bold">Uso de equipamentos</th>
                </tr>
                </thead>

                {janitorial?.equipments && janitorial.equipments.length > 0 && (
                  <thead>
                  <tr>
                    <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Item</th>
                    <th colSpan={2} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Operação</th>
                    <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Usuário</th>
                    <th colSpan={2} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Data/hora </th>
                    <th colSpan={2} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Quantidade</th>
                  </tr>
                  </thead>
                )}

                <tbody>
                {janitorial?.equipments && janitorial.equipments.length > 0 ? (
                  janitorial.equipments.map((equip) => (
                    <tr key={equip.id}>
                      <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{equip.description}</td>
                      <td colSpan={2} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{equip.action_formatted}</td>
                      <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{equip.user_name}</td>
                      <td colSpan={2} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">
                        {equip.date ? format(new Date(equip.date.replace(" ", "T")), "dd/MM/yyyy HH:mm") : ""}
                      </td>
                      <td colSpan={2} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{equip.quantity}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={12} className="border p-4 border-[#d9dada] bg-[#fafafa] text-center text-[#4f4f4f]">
                      Nenhum equipamento registrado.
                    </td>
                  </tr>
                )}
                </tbody>
              </table>
            </div>
            <div className="pb-5">
              <PrintFooter/>
            </div>
          </div>

        </Template.Body>
      </Template>
      <div className="hidden print:block">
        <PrintTemplate title="ZELADORIA" entity={headerSelected}>
          <div className="w-full p-2">
            <table className="table-fixed border-collapse">
              <thead>
              <tr>
                <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Agente da abertura</th>
                <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Data/hora de abertura</th>
                <th colSpan={2} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Status</th>
                <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Solicitante</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td colSpan={3}  className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{agents.find(agent => agent.value === janitorial?.user_start)?.label ?? ""}</td>
                <td colSpan={4}  className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial.date_start ? format(janitorial.date_start, "dd/MM/yyyy HH:mm") : ""}</td>
                <td colSpan={2}  className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.status === "OPEN" ? "Aberto" : "Encerrado"}</td>
                <td colSpan={3}  className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.requester}</td>
              </tr>
              </tbody>
              <thead>
              <tr>
                <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Natureza</th>
                <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Agente de encerramento</th>
                <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Data/hora encerramento</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td colSpan={4} className="w-1/3 border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{reasons.find(reason => reason.value === janitorial?.reason)?.label}</td>
                <td colSpan={4} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{agents.find(agent => agent.value === janitorial?.user_end)?.label}</td>
                <td colSpan={4} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial.date_end ? format(janitorial.date_end, "dd/MM/yyyy HH:mm") : ""}</td>
              </tr>
              </tbody>
              <thead>
              <tr>
                <th colSpan={12} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Descrição</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td colSpan={12} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.description}</td>
              </tr>
              </tbody>
              <thead>
              <tr>
                <th colSpan={12} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Anexo</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td colSpan={12} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">
                  <div className="w-full flex justify-center">
                    { janitorial.janitorial_file &&
                      <img src={`${API_KEEPER}/ged/attach/${janitorial.janitorial_file}`}/>
                    }
                  </div>
                </td>
              </tr>
              </tbody>
            </table>

            <table className="w-full table-fixed border-collapse mt-4">
              <thead>
              <tr>
                <th colSpan={12} className="border text-start p-2 bg-[#f4f4f5] border-[#d9dada] text-[#4f4f4f] font-bold">Endereço</th>
              </tr>
              </thead>
              <thead>
              <tr>
                <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Local pré-cadastrado</th>
                <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Tipo</th>
                <th colSpan={5} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Logradouro</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td colSpan={4} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial.place === "0" ? "" : janitorial?.place}</td>
                <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.type_place}</td>
                <td colSpan={5} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.street}</td>
              </tr>
              </tbody>
              <thead>
              <tr>
                <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Número</th>
                <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Bairro</th>
                <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Cruzamento</th>
                <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Ponto de referência</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.number}</td>
                <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.neighborhood}</td>
                <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.crossroads}</td>
                <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.reference_point}</td>
              </tr>
              </tbody>
              <thead>
              <tr>
                <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Município</th>
                <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Latitude</th>
                <th colSpan={4} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Longitude</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td colSpan={4} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.city}</td>
                <td colSpan={4} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.latitude}</td>
                <td colSpan={4} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{janitorial?.longitude}</td>
              </tr>
              </tbody>
            </table>


            <table className="w-full table-fixed border-collapse mt-4">
              <thead>
              <tr>
                <th colSpan={12} className="border text-start p-2 bg-[#f4f4f5] border-[#d9dada] text-[#4f4f4f] font-bold">Uso de equipamentos</th>
              </tr>
              </thead>

              {janitorial?.equipments && janitorial.equipments.length > 0 && (
                <thead>
                <tr>
                  <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Descrição</th>
                  <th colSpan={2} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Ação</th>
                  <th colSpan={3} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Usuário</th>
                  <th colSpan={2} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Data</th>
                  <th colSpan={2} className="border text-start p-2 bg-[#fafafa] border-[#d9dada] text-[#4f4f4f]">Quantidade</th>
                </tr>
                </thead>
              )}

              <tbody>
              {janitorial?.equipments && janitorial.equipments.length > 0 ? (
                janitorial.equipments.map((equip) => (
                  <tr key={equip.id}>
                    <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{equip.description}</td>
                    <td colSpan={2} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{equip.action_formatted}</td>
                    <td colSpan={3} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{equip.user_name}</td>
                    <td colSpan={2} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">
                      {equip.date ? format(new Date(equip.date.replace(" ", "T")), "dd/MM/yyyy HH:mm") : ""}
                    </td>
                    <td colSpan={2} className="border text-start p-2 border-[#d9dada] text-[#4f4f4f]">{equip.quantity}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={12} className="border p-4 border-[#d9dada] bg-[#fafafa] text-center text-[#4f4f4f]">
                    Nenhum equipamento registrado.
                  </td>
                </tr>
              )}
              </tbody>
            </table>
          </div>
        </PrintTemplate>
      </div>
    </>
  )
}

export default JanitorialPrint;